import http from '@/communication/AuthConnection'

export default async ({ distributorName }) => {
  try {
    const responsePayload = await http.post('/v1/distributor', { distributorName })
    return responsePayload.data
  } catch (e) {
    return Promise.reject(new Error('ok'))
  }
}



// WEBPACK FOOTER //
// ./src/brain/record/distributor/save-new/index.js